module.exports = __webpack_public_path__ + "img/main_menu_corp.cb94c753.svg";